import { GetterTree } from "vuex";
import { RootState } from "../types";
import { Reimbursement } from "./types";

export const getters: GetterTree<Reimbursement, RootState> = {};
